import { CommonResponse } from '@auth_module/services';
import { privateApi } from '@configs/axios-instances';

type FetchAPiKeyPropsType = {
  organization_id: string;
};

type CreateAPiKeyPropsType = {
  name: string;
  organization_id: string;
};

/**
 * Fetch API keys
 * @param {FetchAPiKeyPropsType} params
 * @return {Promise<CommonResponse | undefined>}
 */

export const fetchApiKeys = async (
  params: FetchAPiKeyPropsType
): Promise<CommonResponse | undefined> => {
  return await privateApi.get('/api-key', { params });
};

/**
 * Create apiKey
 * @param {CreateAPiKeyPropsType} payload
 * @return {Promise<CommonResponse | undefined>}
 */

export const createApiKey = async (
  payload: CreateAPiKeyPropsType
): Promise<CommonResponse | undefined> => {
  return await privateApi.post('/api-key', payload);
};
